import RightPopupComponent from "components/RightPopup";

import SelectDate from "components/SelectDate";
import InputPhone from "components/InputPhone";

import './index.less';
import './themes/default.less';
import Avatar from "components/Avatar";
import SpecsPanel from "../../../employee/components/specsPanel";

export default class CreatePopup extends RightPopupComponent {

    constructor(props) {
        super(props);


        this.blankInfo = {

            address: "",
            domainId: 0,
            lkEnabled: true,
            fname: "",
            sname: "",
            lname: "",
            shortName: "",
            phoneNumber: "",
            workPhone: "",
            sex: "MALE",
            birthday: "",
            email: "",
            fireDate: null,
            photoUid: 0,
            roleId: 0,
            status: "WORK",
            isDoctor: false,
            isActive: true,
            hireDate: this._helper.date.toStr(new Date()),
            specs: [],
            experienceBeginning: null,
            education: "",
            characteristic: ""
        };

        let pstate = {
            login: "",
            password: "",
            password2: ""
        };

        this.state = {
            ...this.state,
            info: { ...this.blankInfo },
            tempPhoto: false,
            hasSpec: false,
            pstate: { ...pstate },
        };
    }

    get popupName() {
        return "createEmployeePopup";
    }

    setInfoState(key, value) {
        this.state.info[key] = value;

        if (key === "lname" || key === "fname" || key === "sname") {
            this.checkShortNameValue();
        }
    }

    checkShortNameValue() {
        const { info } = this.state;

        const { lname, fname, sname } = info;

        if (lname !== "" && fname !== "") {
            this.changeInfoState("shortName", this.getShortFormat(lname, fname, sname));
        }
    }

    getShortFormat(lname, fname, sname) {
        let res = `${lname} ${fname[0]}.`;

        if (sname !== "") {
            res += `${sname[0]}.`;
        }

        return res;
    }

    setPasswordState(key, value) {
        this.state.pstate[key] = value;
    }

    changeInfoState(key, value) {
        const info = this.state.info;
        info[key] = value;
        this.setState({ info });
    }

    show(clId, hideCb) {

        this.dialogTitle = "employee.new_employee";
        this.clinicId = clId;
        this.hidCb = hideCb;

        this._specs = [];

        super.show();
    }

    async onShow() {


    }

    formUpdateInfo() {

        const { info } = this.state;
        const { sex, status, lname, fname, sname, shortName,
            phoneNumber, workPhone, birthday, email, address, roleId, lkEnabled, isDoctor, isActive, hireDate } = info;

        const obj = {
            lname,
            fname,
            sname,
            shortName,
            phoneNumber,
            workPhone,
            birthday,
            email,
            address,
            roleId,
            status,
            sex,
            lkEnabled,
            isDoctor,
            isActive,
            hireDate
        };

        return obj;
    }

    async save() {
        const info = this.formUpdateInfo();

        info.domainId = this.clinicId;

        const { pstate, tempPhoto } = this.state;

        const { login, password, password2 } = pstate;

        const mobj = { photo: null, profile: null };

        if (this.checkValidate(info, login, password, password2)) {
            this.hide();

            if (tempPhoto) {
                const infoFile = {
                    fileInfo: { image: tempPhoto, name: tempPhoto.name },
                };

                mobj.photo = infoFile;
            }

            let spArr = [];

            if (this._specs.length > 0) {
                spArr = this._specs.map((it) => {
                    return { specId: it.id, domainId: null };
                });
            }

            info.specs = spArr;

            info.isDoctor = false;

            if (info.specs.length > 0)
                info.isDoctor = true;

            info.login = login;
            info.password = password;

            mobj.profile = info;

            if (this.hidCb?.apply)
                this.hidCb(mobj);

        }

    }


    checkValidate(info, login, password, password2) {

        if (!info.lname) {
            this.showError("client.errorlname");
            this.lnameInput.setFocus();
            return false;
        }

        if (!info.fname) {
            this.showError("client.errorfname");
            this.fnameInput.setFocus();
            return false;
        }

        if (!info.phoneNumber) {
            this.showError("employee.errorPhoneNumber");
            return false;
        }

        if (!info.roleId) {
            this.showError("employee.errorRole");
            return false;
        }

        if (!login) {
            this.showError("employee.errorLogin");
            this.loginInput.setFocus();
            return false;
        }

        if (!this.checkPassword(password, password2)) {
            this.showError("employee.errorPassword");
            this.passwordInput.setFocus();
            return false;
        }

        return true;
    }

    checkPassword(password, password2) {

        if (password !== "" &&
            password2 !== "" &&
            password.length >= 8 &&
            password === password2
        ) {
            return true;
        }

        return false;

    }

    onChangeAddres(value) {
        this.state.info.address = value;
    }


    onChangeSex(value) {
        const sex = {
            0: "MALE",
            1: "FEMALE"
        };

        this.changeInfoState("sex", value ? sex[value] : "NA");
    }


    onChangeDateBirth(value) {
        this.state.info.birthday = value;
    }


    onChangeEmail(value) {
        this.state.info.email = value;
    }

    onChangeAvatar(selectedFile) {
        this.changeState("tempPhoto", selectedFile);
    }

    openDialogAvatarUpload(info) {
        this._helper.openDialog("avatarUpload", info, this.onChangeAvatar.bind(this));
    }


    renderButtons() {

        return super.renderButtons();

    }

    onChangeSpecs(it, _status) {
        if (_status) {
            this._specs.push(it);
        } else {

            let spArr = this._specs.filter(sIt => it.id !== sIt.id);
            this._specs = spArr;
        }
    }


    onChangeRole(value) {
        this.setInfoState("roleId", value);
        this.setState({ hasSpec: this._helper.isRoleHasSpec(value) });
    }

    onChangeBeginDate(value) {
        this.setInfoState("hireDate", `${value}T02:00:00.000+00:00`);
    }
    getISODate(sdate) {
        if (sdate) {
            let t = sdate.split("T");

            if (t.length === 2) {
                return t[0];
            }
        }

        return this._helper.date.toDateServerStr(new Date());
    }

    renderAvatar() {
        const { info, tempPhoto } = this.state;
        const { photoUid, sex } = info;

        return (<div className="flex gap16">
            <Avatar
                id={photoUid}
                tempPhoto={tempPhoto ? URL.createObjectURL(tempPhoto) : false}
                sex={sex}
                size={120}
                radius={8}
                iconWidth={120}
                iconHeight={120}
            />
            {<div className="flex between col">
                <div className="buttonIcon">
                    {photoUid ? this.insertButtonIcon({
                        name: "close",
                        tooltip: "main.uploadFile",
                        onClick: null
                    }) : <></>}
                </div>
                <div >
                    {this.insertButton({
                        type: "secondary",
                        size: "small",
                        onClick: this.openDialogAvatarUpload.bind(this, info),
                        label: "employee.downloadPhoto"
                    })}
                </div>
            </div>}
        </div>);
    }

    renderContent() {
        const { info, pstate, hasSpec } = this.state;
        const { employeeStatuses, rolesList } = this._config;
        const { sex, status, lname, fname, sname, shortName,
            phoneNumber, workPhone, birthday, email, address, roleId, hireDate } = info;

        const sexValue = sex === undefined ? this.getSexByName(lname, fname) : sex;

        const { login, password, password2 } = pstate;

        return (
            <div className="flex gap16 col" style={{ width: "500px" }}>
                {this.renderAvatar()}
                <div className="inputs flex gap4">
                    {this.insertInput({
                        value: lname,
                        itemStyle: "flex1",
                        label: "main.lname",
                        placeHolder: "main.lnamePlace",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: this.setInfoState.bind(this, "lname"),
                        required: true,
                    })}
                    {this.insertInput({
                        value: fname,
                        itemStyle: "flex1",
                        label: "main.fname",
                        placeHolder: "main.fnamePlace",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: this.setInfoState.bind(this, "fname"),
                        required: true,
                    })}
                    {this.insertInput({
                        value: sname,
                        itemStyle: "flex1",
                        label: "main.sname",
                        placeHolder: "main.snamePlace",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: this.setInfoState.bind(this, "sname"),
                    })}
                </div>
                {<SelectDate currentday={birthday} onClick={this.onChangeDateBirth.bind(this)} />}
                <div className="flex col gap8">
                    {this.insertSexSelect({
                        value: sexValue,
                        label: "client.sex",
                        onChange: this.onChangeSex.bind(this),
                    })}
                </div>
                <div className="flex flex1 gap16">

                    {this.insertInputTooltip({
                        value: shortName,
                        itemStyle: "flex1",
                        label: "employee.fio_short",
                        tooltip: "employee.fio_short_tooltip",
                        placeHolder: "",
                        onChange: this.setInfoState.bind(this, "shortName"),
                    })}

                    <InputPhone
                        value={phoneNumber}
                        itemStyle="flex1"
                        label="employee.tel"
                        onChange={this.setInfoState.bind(this, "phoneNumber")}
                        required={true}
                    />
                </div>

                <div className="flex flex1 gap16">
                    <InputPhone
                        value={workPhone}
                        itemStyle="flex1"
                        label="employee.telHome"
                        onChange={this.setInfoState.bind(this, "workPhone")}

                    />
                    {this.insertInput({
                        value: email,
                        itemStyle: "flex1",
                        label: "employee.email",
                        placeHolder: "mail@mail.ru",
                        onChange: this.onChangeEmail.bind(this),

                    })}
                </div>

                <div className="inputFull">
                    {this.insertInput({
                        value: address,
                        itemStyle: "flex1",
                        label: "employee.address",
                        placeHolder: "client.exampleAddress",
                        onChange: this.onChangeAddres.bind(this)
                    })}
                </div>

                {hasSpec &&
                    <>
                        {this.insertParagraf("employee.specsStomat")}
                        <SpecsPanel items={this._specs} onChange={this.onChangeSpecs.bind(this)} />
                    </>
                }

                {this.insertLine()}
                {this.insertContentTitle("employee.system")}

                <div className="flex flex1 gap16">
                    {this.insertInput({
                        value: login,
                        itemStyle: "flex1",
                        label: "employee.login",
                        placeHolder: "",
                        onChange: this.setPasswordState.bind(this, "login"),
                        required: true
                    })}
                    {this.insertInput({
                        value: password,
                        itemStyle: "flex1",
                        label: "employee.password",
                        type: "password",
                        placeHolder: "",
                        onChange: this.setPasswordState.bind(this, "password"),
                        required: true,
                    })}

                    {this.insertInput({
                        value: password2,
                        itemStyle: "flex1",
                        label: "employee.password_confirm",
                        type: "password",
                        placeHolder: "",
                        onChange: this.setPasswordState.bind(this, "password2"),
                        required: true,
                    })}
                </div>

                <div className="flex flex1 gap16">
                    {this.insertSelect({
                        value: roleId,
                        label: "employee.role_system",
                        showLeftIcon: false,
                        placeHolder: "main.notIndicated",
                        translate: true,
                        items: rolesList,
                        onChange: this.onChangeRole.bind(this),
                    })}
                    {this.insertSelect({
                        value: status,
                        label: "employee.status",
                        showLeftIcon: false,
                        placeHolder: "main.notIndicated",
                        translate: true,
                        items: employeeStatuses,
                        onChange: this.setInfoState.bind(this, "status"),
                    })}
                    {this.insertInputDate({
                        value: this.getISODate(hireDate),
                        //itemStyle: "flex1",
                        label: "employee.date_start",
                        type: "date",
                        onChange: this.onChangeBeginDate.bind(this),

                    })}
                </div>


            </div>
        );
    }
}
